// import {ElLoading, ElButton, ElTooltip, ElForm, ElFormItem, ElInput, ElDialog, ElDatePicker} from "element-plus";
import ElementPlus from 'element-plus'
import app from "../app";
import ru from "element-plus/lib/locale/lang/ru.js"
// import locale from 'element-plus/lib/locale'

// configure language
app.use(ElementPlus, {locale: ru})
